<!-- Full-screen veil (blurred backdrop) holding three stroke-drawn letters —
     I, D, P — each path drawn by an animated dash, staggered so the word
     writes itself left to right. Adapted from a Uiverse.io "YOU" loader
     (SelfMadeSystem); the letterforms and the palette are ours. -->
<div class="loader" *ngIf="loaderService.isLoading()">
    <div class="idp-loader" role="status" aria-label="Loading">
        <!-- Gradients live in a zero-size svg so they can be referenced by all
             three letters. Stop colours are set in the stylesheet, which is
             what lets them follow the brand tokens and the dark scheme. -->
        <svg height="0" width="0" viewBox="0 0 64 64" class="idp-defs" aria-hidden="true">
            <defs>
                <linearGradient gradientUnits="userSpaceOnUse" x1="0" y1="62" x2="0" y2="2" id="idp-grad-i">
                    <stop class="idp-stop-a"></stop>
                    <stop class="idp-stop-b" offset="1"></stop>
                </linearGradient>
                <linearGradient gradientUnits="userSpaceOnUse" x1="0" y1="62" x2="0" y2="2" id="idp-grad-d">
                    <stop class="idp-stop-b"></stop>
                    <stop class="idp-stop-c" offset="1"></stop>
                </linearGradient>
                <linearGradient gradientUnits="userSpaceOnUse" x1="0" y1="62" x2="0" y2="2" id="idp-grad-p">
                    <stop class="idp-stop-a"></stop>
                    <stop class="idp-stop-c" offset="1"></stop>
                </linearGradient>
            </defs>
        </svg>

        <!-- I -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" height="64" width="64" class="idp-letter" aria-hidden="true">
            <path class="idp-dash" pathLength="360" stroke="url(#idp-grad-i)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" d="M 18,6 H 46 M 32,6 V 58 M 18,58 H 46"></path>
        </svg>

        <!-- D -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" height="64" width="64" class="idp-letter" aria-hidden="true">
            <path class="idp-dash" pathLength="360" stroke="url(#idp-grad-d)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" d="M 14,58 V 6 h 16 a 26 26 0 0 1 0 52 Z"></path>
        </svg>

        <!-- P -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" height="64" width="64" class="idp-letter" aria-hidden="true">
            <path class="idp-dash" pathLength="360" stroke="url(#idp-grad-p)" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" d="M 16,58 V 6 h 16 a 15 15 0 0 1 0 30 H 16"></path>
        </svg>
    </div>
</div>
